import { useAuthStore } from '@/stores/auth';

export default defineNuxtRouteMiddleware((to, from) => {
  const authStore = useAuthStore();

  // 检查用户是否已登录
  if (!authStore.isAuthenticated) {
    console.log('此页面需要登录权限:',to)
    // 如果未登录，重定向到登录页面
    return navigateTo('/login');
  }
});